<script setup lang="ts">
import { UserFilled } from '@element-plus/icons-vue'
import { loginOut } from '@mp/api/gateway/UserControler.js'
import { useMutation } from '@tanstack/vue-query'
import { useUserInfo } from '@mp/hooks'

const AvatarImage = `${import.meta.env.VITE_B_URL}/merchant-platform/avatar-1.svg`
const { userInfo, isHeadOffice } = useUserInfo()

// #region 退出登录
const { mutateAsync: mutateLoginOutAsync } = useMutation({
  mutationFn: loginOut,
})

async function handleLogOut() {
  await mutateLoginOutAsync()

  sessionStorage.clear()
  fetch('/sdppro/api/use/logout', { keepalive: true }).catch(() => {})
  window.location.replace('/merchant-platform/#/new')
}
</script>

<template>
  <el-dropdown
    placement="top-end"
  >
    <div class="text-white flex-inline overflow-hidden leading-none items-center outline-none" style="--el-text-color-disabled: white; --el-color-white: var(--n-600)">
      <el-avatar :size="24" :icon="UserFilled" class="mr-2" />
      <span class="flex-1 truncate max-w-[100px]">{{ userInfo?.operatorName }} </span>
      <span>({{ userInfo?.merchantId }})</span>
      <span v-if="isHeadOffice" class="text-xs border border-[rgba(255,255,255,0.5)] rounded-full px-2 py-[2px] ml-2 text-white">
        总部
      </span>
    </div>
    <template #dropdown>
      <el-dropdown-menu>
        <div class="py-3 flex items-center border-b border-b-[0.5px] mx-2 px-2 w-[280px]">
          <img :src="AvatarImage" class=" block w-8 h-8 mr-3 rounded-full overflow-hidden" alt="">
          <div class="flex-1">
            <p class="text-n-800 text-sm font-medium">
              {{ userInfo?.operatorName }}
            </p>
            <p class="text-n-90 text-xs mt-1">
              商户号: {{ userInfo?.merchantId }}
            </p>
          </div>
        </div>

        <el-dropdown-item @click="handleLogOut">
          退出登录
        </el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>
